/**
 * Mock Data Service
 * Provides dummy data for all modules
 */

// Mock Agencies Data
export const mockAgencies = [
  {
    id: '1',
    name: 'NASA',
    country: 'United States',
    foundedYear: 1958,
    founder: 'Dwight D. Eisenhower',
    headquarters: 'Washington, D.C.',
    description: 'National Aeronautics and Space Administration - Leading space exploration agency.',
    activeRockets: 15,
    scientistsCount: 250,
    missionsCount: 450
  },
  {
    id: '2',
    name: 'SpaceX',
    country: 'United States',
    foundedYear: 2002,
    founder: 'Elon Musk',
    headquarters: 'Hawthorne, California',
    description: 'Private aerospace manufacturer and space transportation company.',
    activeRockets: 8,
    scientistsCount: 120,
    missionsCount: 320
  },
  {
    id: '3',
    name: 'Roscosmos',
    country: 'Russia',
    foundedYear: 1992,
    founder: 'Boris Yeltsin',
    headquarters: 'Moscow',
    description: 'Russian space agency responsible for space programs and cosmonautics.',
    activeRockets: 12,
    scientistsCount: 180,
    missionsCount: 380
  },
  {
    id: '4',
    name: 'ESA',
    country: 'Europe',
    foundedYear: 1975,
    founder: 'European Space Agency',
    headquarters: 'Paris, France',
    description: 'European Space Agency - Intergovernmental organization dedicated to space exploration.',
    activeRockets: 10,
    scientistsCount: 150,
    missionsCount: 280
  },
  {
    id: '5',
    name: 'ISRO',
    country: 'India',
    foundedYear: 1969,
    founder: 'Vikram Sarabhai',
    headquarters: 'Bengaluru',
    description: 'Indian Space Research Organisation - National space agency of India.',
    activeRockets: 9,
    scientistsCount: 100,
    missionsCount: 200
  }
];

// Mock Rockets Data
export const mockRockets = [
  {
    id: '1',
    name: 'Falcon 9',
    type: 'Reusable',
    manufacturer: 'SpaceX',
    height: 70,
    diameter: 3.7,
    mass: 549000,
    payloadCapacity: 22800,
    stages: 2,
    fuelType: 'RP-1 / LOX',
    firstLaunch: '2010-06-04',
    status: 'Active',
    agencyId: '2'
  },
  {
    id: '2',
    name: 'Falcon Heavy',
    type: 'Reusable',
    manufacturer: 'SpaceX',
    height: 70,
    diameter: 12.2,
    mass: 1420788,
    payloadCapacity: 63800,
    stages: 2,
    fuelType: 'RP-1 / LOX',
    firstLaunch: '2018-02-06',
    status: 'Active',
    agencyId: '2'
  },
  {
    id: '3',
    name: 'SLS Block 1',
    type: 'Heavy Lift',
    manufacturer: 'NASA',
    height: 98,
    diameter: 8.4,
    mass: 2608000,
    payloadCapacity: 95000,
    stages: 2,
    fuelType: 'LH2 / LOX',
    firstLaunch: '2022-11-16',
    status: 'Active',
    agencyId: '1'
  },
  {
    id: '4',
    name: 'Soyuz-2',
    type: 'Expendable',
    manufacturer: 'Roscosmos',
    height: 46.3,
    diameter: 2.95,
    mass: 312000,
    payloadCapacity: 8200,
    stages: 3,
    fuelType: 'RP-1 / LOX',
    firstLaunch: '2004-11-08',
    status: 'Active',
    agencyId: '3'
  },
  {
    id: '5',
    name: 'Ariane 5',
    type: 'Expendable',
    manufacturer: 'ESA',
    height: 52,
    diameter: 5.4,
    mass: 777000,
    payloadCapacity: 21000,
    stages: 2,
    fuelType: 'LH2 / LOX',
    firstLaunch: '1996-06-04',
    status: 'Active',
    agencyId: '4'
  }
];

// Mock Launches Data
export const mockLaunches = [
  {
    id: '1',
    missionName: 'Starlink Group 7-15',
    rocketId: '1',
    launchDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days from now
    launchSite: 'Vandenberg Space Force Base',
    agencyId: '2',
    missionType: 'Satellite Deployment',
    status: 'Scheduled',
    payloadDetails: '22 Starlink satellites to LEO'
  },
  {
    id: '2',
    missionName: 'Artemis III',
    rocketId: '3',
    launchDate: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString(), // 10 days from now
    launchSite: 'Kennedy Space Center',
    agencyId: '1',
    missionType: 'Lunar Landing',
    status: 'Scheduled',
    payloadDetails: 'Orion spacecraft with crew'
  },
  {
    id: '3',
    missionName: 'CRS-29',
    rocketId: '1',
    launchDate: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toISOString(), // 15 days from now
    launchSite: 'Kennedy Space Center',
    agencyId: '2',
    missionType: 'Resupply',
    status: 'Scheduled',
    payloadDetails: 'Dragon capsule to ISS'
  },
  {
    id: '4',
    missionName: 'Mars Sample Return',
    rocketId: '3',
    launchDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days ago
    launchSite: 'Kennedy Space Center',
    agencyId: '1',
    missionType: 'Mars Mission',
    status: 'Completed',
    payloadDetails: 'Sample return orbiter'
  },
  {
    id: '5',
    missionName: 'Soyuz MS-24',
    rocketId: '4',
    launchDate: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(), // 20 days ago
    launchSite: 'Baikonur Cosmodrome',
    agencyId: '3',
    missionType: 'Crew Transport',
    status: 'Completed',
    payloadDetails: 'Crew to ISS'
  }
];

// Mock Scientists Data
export const mockScientists = [
  {
    id: '1',
    name: 'Dr. Katherine Johnson',
    country: 'United States',
    field: 'Aerospace',
    agencyId: '1',
    rocketsWorkedOn: ['SLS Block 1'],
    satellitesWorkedOn: ['Hubble Space Telescope'],
    biography: 'Pioneering mathematician and physicist who calculated trajectories for NASA missions.',
    achievements: 'Calculated trajectories for Apollo 11 moon landing, Presidential Medal of Freedom'
  },
  {
    id: '2',
    name: 'Dr. Elon Musk',
    country: 'United States',
    field: 'Engineering',
    agencyId: '2',
    rocketsWorkedOn: ['Falcon 9', 'Falcon Heavy', 'Starship'],
    satellitesWorkedOn: ['Starlink Constellation'],
    biography: 'Engineer and entrepreneur, founder of SpaceX, leading reusable rocket technology.',
    achievements: 'First privately funded liquid-propellant rocket to reach orbit, Reusable rocket technology'
  },
  {
    id: '3',
    name: 'Dr. Wernher von Braun',
    country: 'Germany/United States',
    field: 'Aerospace',
    agencyId: '1',
    rocketsWorkedOn: ['Saturn V'],
    satellitesWorkedOn: ['Explorer 1'],
    biography: 'German-American aerospace engineer who developed the Saturn V rocket.',
    achievements: 'Led development of Saturn V, instrumental in Apollo program'
  },
  {
    id: '4',
    name: 'Dr. Sergey Korolev',
    country: 'Russia',
    field: 'Aerospace',
    agencyId: '3',
    rocketsWorkedOn: ['Soyuz', 'R-7'],
    satellitesWorkedOn: ['Sputnik 1'],
    biography: 'Soviet rocket engineer and spacecraft designer, chief designer of Soviet space program.',
    achievements: 'Sputnik 1, First human in space (Yuri Gagarin)'
  },
  {
    id: '5',
    name: 'Dr. Vikram Sarabhai',
    country: 'India',
    field: 'Astrophysics',
    agencyId: '5',
    rocketsWorkedOn: ['SLV', 'ASLV'],
    satellitesWorkedOn: ['Aryabhata'],
    biography: 'Indian physicist and astronomer, founder of ISRO.',
    achievements: 'Founded ISRO, Launched India\'s first satellite'
  }
];

// Mock Satellites Data
export const mockSatellites = [
  {
    id: '1',
    name: 'Hubble Space Telescope',
    orbitType: 'LEO',
    purpose: 'Astronomical Observation',
    launchDate: '1990-04-24',
    rocketId: '3',
    agencyId: '1',
    status: 'Active',
    expectedLifespan: '2030-2040'
  },
  {
    id: '2',
    name: 'James Webb Space Telescope',
    orbitType: 'L2',
    purpose: 'Infrared Astronomy',
    launchDate: '2021-12-25',
    rocketId: '5',
    agencyId: '1',
    status: 'Active',
    expectedLifespan: '2030-2045'
  },
  {
    id: '3',
    name: 'Starlink Satellite',
    orbitType: 'LEO',
    purpose: 'Internet Service',
    launchDate: '2019-05-24',
    rocketId: '1',
    agencyId: '2',
    status: 'Active',
    expectedLifespan: '5-7 years'
  },
  {
    id: '4',
    name: 'International Space Station',
    orbitType: 'LEO',
    purpose: 'Space Laboratory',
    launchDate: '1998-11-20',
    rocketId: '4',
    agencyId: '3',
    status: 'Active',
    expectedLifespan: '2030-2031'
  },
  {
    id: '5',
    name: 'GPS III Satellite',
    orbitType: 'MEO',
    purpose: 'Navigation',
    launchDate: '2018-12-23',
    rocketId: '2',
    agencyId: '1',
    status: 'Active',
    expectedLifespan: '15 years'
  }
];

// Mock Articles Data
export const mockArticles = [
  {
    id: '1',
    title: 'The Future of Reusable Rockets',
    category: 'Technology',
    content: 'Reusable rockets are revolutionizing space exploration by reducing costs and increasing launch frequency...',
    author: 'Dr. Sarah Martinez',
    authorId: 'subscriber1',
    publishedDate: '2024-01-15',
    status: 'Live'
  },
  {
    id: '2',
    title: 'Mars Colonization: Challenges and Opportunities',
    category: 'Exploration',
    content: 'As we look towards Mars colonization, numerous challenges must be addressed including life support systems, radiation protection, and sustainable agriculture...',
    author: 'Dr. James Chen',
    authorId: 'subscriber2',
    publishedDate: '2024-01-20',
    status: 'Live'
  },
  {
    id: '3',
    title: 'Understanding Rocket Propulsion',
    category: 'Education',
    content: 'Rocket propulsion works on the principle of action and reaction, following Newton\'s third law of motion...',
    author: 'Dr. Maria Rodriguez',
    authorId: 'subscriber3',
    publishedDate: '2024-02-01',
    status: 'Live'
  }
];

// Mock News Data
export const mockNews = [
  {
    id: '1',
    headline: 'Historic Mars Mission Success',
    summary: 'NASA successfully lands rover on Mars, beginning new era of exploration.',
    content: 'The mission represents a major milestone in space exploration...',
    source: 'Space News Daily',
    date: '2024-02-10'
  },
  {
    id: '2',
    headline: 'SpaceX Breaks Launch Record',
    summary: 'Company achieves 100 successful launches in a single year.',
    content: 'SpaceX continues to push boundaries in commercial space flight...',
    source: 'Aerospace Today',
    date: '2024-02-08'
  },
  {
    id: '3',
    headline: 'New Space Telescope Discoveries',
    summary: 'James Webb Telescope reveals stunning images of distant galaxies.',
    content: 'The telescope has provided unprecedented views of the early universe...',
    source: 'Astronomy Weekly',
    date: '2024-02-05'
  }
];

// Mock Books Data
export const mockBooks = [
  {
    id: '1',
    title: 'Introduction to Rocket Science',
    author: 'Dr. John Anderson',
    category: 'Rocket Science',
    price: 49.99,
    description: 'Comprehensive guide to rocket propulsion and space flight engineering.',
    rating: 4.8
  },
  {
    id: '2',
    title: 'The Space Age: A History',
    author: 'Emily Watson',
    category: 'Astronomy',
    price: 34.99,
    description: 'Detailed history of space exploration from Sputnik to modern missions.',
    rating: 4.6
  },
  {
    id: '3',
    title: 'Aerospace Engineering Fundamentals',
    author: 'Dr. Michael Brown',
    category: 'Engineering',
    price: 59.99,
    description: 'Essential textbook for aerospace engineering students.',
    rating: 4.9
  },
  {
    id: '4',
    title: 'Mars: The Next Frontier',
    author: 'Sarah Thompson',
    category: 'Exploration',
    price: 39.99,
    description: 'Exploring the challenges and possibilities of Mars colonization.',
    rating: 4.7
  },
  {
    id: '5',
    title: 'Satellite Technology Explained',
    author: 'Dr. Robert Lee',
    category: 'Rocket Science',
    price: 44.99,
    description: 'Understanding satellite design, orbits, and applications.',
    rating: 4.5
  }
];

// Service Functions
export const getAgencyById = (id) => {
  return mockAgencies.find(agency => agency.id === id);
};

export const getRocketById = (id) => {
  return mockRockets.find(rocket => rocket.id === id);
};

export const getLaunchById = (id) => {
  return mockLaunches.find(launch => launch.id === id);
};

export const getScientistById = (id) => {
  return mockScientists.find(scientist => scientist.id === id);
};

export const getSatelliteById = (id) => {
  return mockSatellites.find(satellite => satellite.id === id);
};

export const getRocketsByAgency = (agencyId) => {
  return mockRockets.filter(rocket => rocket.agencyId === agencyId);
};

export const getLaunchesByRocket = (rocketId) => {
  return mockLaunches.filter(launch => launch.rocketId === rocketId);
};

export const getUpcomingLaunches = () => {
  const now = new Date();
  return mockLaunches.filter(launch => new Date(launch.launchDate) > now);
};

export const getPastLaunches = () => {
  const now = new Date();
  return mockLaunches.filter(launch => new Date(launch.launchDate) <= now);
};

export const getRecentLaunches = (days = 30) => {
  const now = new Date();
  const cutoff = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
  return mockLaunches.filter(launch => {
    const launchDate = new Date(launch.launchDate);
    return launchDate <= now && launchDate >= cutoff;
  });
};
